// extracted by mini-css-extract-plugin
module.exports = {"area":"LoadingArea_area__3bekD","content":"LoadingArea_content__3gPQ5","loading":"LoadingArea_loading__3qktg","indicator":"LoadingArea_indicator__2BXOX"};